import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=21ee53dc&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=21ee53dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee53dc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Animation: require('/vercel/path0/components/Animation.vue').default,Footer: require('/vercel/path0/components/Footer.vue').default})
